/**
 * New Season writes and the dashboard: which writes re-pull the V1 tree the
 * dashboard reads (distribution_data), and which field to select once an
 * "Activate now" re-pull lands.
 *
 * CommonJS and dependency-free so they can be unit-tested with `node --test`
 * (see sciroot-webapp newSeason __tests__).
 */

// A pre-season (template) lives only in the new tables, so the dashboard
// never shows it; an active or archived season is a dashboard field.
const isDashboardSeason = season =>
  Boolean(season) && season.state !== 'template';

// "Activate now" archives the block's previous active season. When that is
// the field the dashboard has selected, select the new active season instead
// of letting the reselect fall back to the farming unit's first field.
// Returns the field id to select, or null to keep the selection.
const fieldToSelectAfterActivation = (selectedFieldId, activation) =>
  selectedFieldId &&
  activation?.season_id &&
  (activation.archived_season_ids || []).includes(selectedFieldId)
    ? activation.season_id
    : null;

module.exports = { isDashboardSeason, fieldToSelectAfterActivation };
